import React, { lazy, Component } from "react";
import { NavLink } from "react-router-dom";
import Spinner from "../UI/Spinner/Spinner";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Image from "react-bootstrap/Image";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import "./Header.scss";
import { toast } from "react-toastify";
class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      //isMenuOpen: false
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.setState({ loading: false });
  }
  handleToggle = () => {
    document.body.classList.toggle("menuOpen");
    //this.setState({ isMenuOpen: !this.state.isMenuOpen });
  };
  CloseNav = () => {
    document.querySelector(".hamburger").click();
  };
  CloseProfile = () => {
    document.querySelector(".dropdown-toggle").click();
  };

  scrollToBrand = () => {
    document.getElementById("brand").click();
  };
  render() {
    //const isMenuOpen = this.state.isMenuOpen;
    return (
      <>
        {this.state.loading === true ? <Spinner /> : null}
        <header>
          {/* <Navbar>
            <Container fluid="lg">
               <Navbar.Brand href="#home"></Navbar.Brand>
             
              
              <div className="loginAndUser d-flex align-items-center">
                <Form.Group className="formField">
                  <Form.Select
                    className="form-control"
                    onChange={(event) => this.setfootertext(event)}
                    value = {localStorage.getItem("location")}
                  >
                    <option value="11">Burhanpur</option>
                  </Form.Select>
                </Form.Group>
                {localStorage.token !== "" &&
                localStorage.token !== undefined ? (
                  <>
                   
                    <Dropdown align="end">
                      <Dropdown.Toggle>
                        <Image
                          className=""
                          src={
                            "data:image/png;base64," +
                            localStorage.getItem("photo")
                          }
                          onError={(e) =>
                            (e.target.src = require("../../styles/images/user.png"))
                          }
                          alt={2}
                        />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <span className="dropdown-item">
                          {localStorage.getItem("username")}
                        </span>
                        <NavLink
                          to="/mybooking"
                          className="dropdown-item"
                          onClick={() => this.CloseProfile()}
                        >
                          My Booking
                        </NavLink>
                       
                        <NavLink to="/logout" className="dropdown-item">
                          Logout
                        </NavLink>
                      </Dropdown.Menu>
                    </Dropdown>
                  </>
                ) : null}
              </div>
               <div className="menuOverlay" onClick={this.handleToggle}></div>
              <div className="hamburger" onClick={this.handleToggle}>
                <div></div>
              </div>
              <Nav className="me-md-auto ms-md-auto">
                <div className="hamburger" onClick={this.handleToggle}>
                  <div></div>
                </div>
               
                <NavLink
                  to="/room"
                  onClick={() => this.CloseNav()}
                  className="nav-link"
                >
                  Rooms
                </NavLink>
               
                 <NavLink
                  to="/mybooking"
                  onClick={() => this.CloseNav()}
                  className="nav-link"
                >
                  My Bookings
                </NavLink>
                <NavLink
                  to="/contact"
                  onClick={() => this.CloseNav()}
                  className="nav-link"
                >
                  Contact
                </NavLink>
              </Nav>
            </Container>
          </Navbar> */}
          <Navbar>
            <Container fluid="lg">
              <div className="menuOverlay" onClick={this.handleToggle}></div>
              <div className="hamburger" onClick={this.handleToggle}>
                <div></div>
              </div>
              <Navbar.Brand href="#room"></Navbar.Brand>
              <Nav className="me-md-auto ms-md-auto">
                <div className="hamburger" onClick={this.handleToggle}>
                  <div></div>
                </div>

                <a
                  // to="/1"
                  href={"https://mazaraat.org/#/"+(localStorage.mn ===undefined ? "":localStorage.mn)}
                  onClick={() => this.CloseNav()}
                  className="nav-link"
                >
                  {localStorage.mn}
                </a>
               
                <NavLink
                  to="/room"
                  onClick={() => this.CloseNav()}
                  className="nav-link"
                >
                  Rooms
                </NavLink>
               
                 <NavLink
                  to="/mybooking"
                  onClick={() => this.CloseNav()}
                  className="nav-link"
                >
                  My Bookings
                </NavLink>
                <NavLink
                  to="/contact"
                  onClick={() => this.CloseNav()}
                  className="nav-link"
                >
                  Contact
                </NavLink>
              </Nav>
              <div className="loginAndUser d-flex align-items-center">
                {/* <Form.Group className="formField">
                  <Form.Select
                    className="form-control"
                    onChange={(event) => this.setfootertext(event)}
                    value = {localStorage.getItem("location")}
                  >
                    <option value="11">Burhanpur</option>
                   
                  </Form.Select>
                </Form.Group> */}
                {localStorage.token !== "" &&
                localStorage.token !== undefined ? (
                  <>
                  
                    <Dropdown align="end">
                      <Dropdown.Toggle>
                        <Image
                          className=""
                          src={
                            "data:image/png;base64," +
                            localStorage.getItem("photo")
                          }
                          onError={(e) =>
                            (e.target.src = require("../../styles/images/user.png"))
                          }
                          alt={2}
                         
                        />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <span className="dropdown-item">
                          {localStorage.getItem("username")}
                        </span>
                        <NavLink
                          to="/mybooking"
                          className="dropdown-item"
                          onClick={() => this.CloseProfile()}
                        >
                          My Booking
                        </NavLink>
                      
                       {/* <a href="http://localhost:3000/" className="dropdown-item">
                          Logout
                        </a> */}
                        <NavLink to="/logout" className="dropdown-item">
                          Logout
                        </NavLink>
                      </Dropdown.Menu>
                    </Dropdown>
                  </>
                ) : null}
              </div>
            </Container>
          </Navbar>
        </header>

      </>
    );
  }
}

export default Header;
